'use client'
import { HeaderContextProvider } from '@dustin-web/microsite-baselayout/src/components/header/header-context'
import MobileClient from '@dustin-web/microsite-baselayout/src/components/header/header-mobile'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

export const AppHeaderResponsive = ({ children }: { children: React.ReactNode }) => {
  const { isSmallScreen } = useResponsive()
  return (
    <HeaderContextProvider>{isSmallScreen ? <MobileClient /> : children}</HeaderContextProvider>
  )
}

export default AppHeaderResponsive
